import TranslationService from "../../services/TranslationService";
import Vue from "vue";
import { mapState } from "vuex";
import { isDefined } from "../../helper/utils";
const NotificationService = require("../../services/NotificationService");

const SHIPPING_ICON_BASE = "https://cdn.bio-kinder.de/frontend/images/biokindertheme/icons/";
const SHIPPING_ICONS = {
    freight: {
        iconSrc: SHIPPING_ICON_BASE + "dhl.svg",
        iconAlt: "DHL 2-Mann-Handling",
        isFreight: true
    },
    freightEvening: {
        iconSrc: SHIPPING_ICON_BASE + "dhl_spaet.svg",
        iconAlt: "DHL 2-Mann-Handling Spaetzustellung",
        isFreight: true
    },
    freightSaturday: {
        iconSrc: SHIPPING_ICON_BASE + "dhl_samstag.svg",
        iconAlt: "DHL 2-Mann-Handling Samstag",
        isFreight: true
    },
    freightRestricted: {
        iconSrc: SHIPPING_ICON_BASE + "spedition.svg",
        iconAlt: "Spedition"
    },
    email: {
        iconSrc: SHIPPING_ICON_BASE + "email.svg",
        iconAlt: "E-Mail Versand"
    },
    parcel: {
        iconSrc: "https://cdn.bio-kinder.de/frontend/images/icons/paketversand.svg",
        iconAlt: "Paketversand"
    }
};
const SHIPPING_PROFILE_TYPES = {
    7: "freight",
    43: "freight",
    23: "freightEvening",
    45: "freightEvening",
    22: "freightSaturday",
    44: "freightSaturday",
    52: "email"
};

export default Vue.component("shipping-profile-select", {

    props:
    {
        template:
        {
            type: String,
            default: "#vue-shipping-profile-select"
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        paymentContainerIsOverwritten:
        {
            type: Boolean,
            default: false
        }
    },

    computed:
    {
        shippingProfilePresentation()
        {
            const presentation = Object.create(null);
            const showFreightDetails = this.showFreightDetails;

            for (const shippingProfile of this.shippingProfileList)
            {
                const profileId = shippingProfile.parcelServicePresetId;
                const profileIcon = SHIPPING_ICONS[SHIPPING_PROFILE_TYPES[Number(profileId)] || "parcel"];
                const isFreight = !!profileIcon.isFreight;
                const icon = isFreight && !showFreightDetails ? SHIPPING_ICONS.freightRestricted : profileIcon;

                presentation[profileId] = {
                    iconSrc: icon.iconSrc,
                    iconAlt: icon.iconAlt,
                    isFreight,
                    showInfo: isFreight && showFreightDetails
                };
            }

            return presentation;
        },

        ...mapState({
            shippingProfileList: state => state.checkout.shipping.shippingProfileList,
            maxDeliveryDays: state => state.checkout.shipping.maxDeliveryDays,
            shippingProfileId: state => state.checkout.shipping.shippingProfileId,
            showFreightDetails: state => state.checkout.shipping.showFreightDetails,
            showError: state => state.checkout.validation.shippingProfile.showError,
            isBasketLoading: state => state.basket.isBasketLoading,
            isCheckoutReadonly: state => state.checkout.readOnly,
            selectedPaymentMethodId: state => state.checkout.payment.methodOfPaymentId
        })
    },

    /**
     * Add a shipping provider
     * Initialise the event listener
     */
    created()
    {
        this.$store.commit("setShippingProfileValidator", this.validate);
    },

    methods:
    {
        /**
         * Method on shipping profile changed
         */
        onShippingProfileChange(shippingProfileId)
        {
            this.$store.dispatch("selectShippingProfile", this.shippingProfileList.find(shippingProfile => shippingProfile.parcelServicePresetId === shippingProfileId))
                .then(data =>
                {
                    document.dispatchEvent(new CustomEvent("afterShippingProfileChanged", { detail: this.shippingProfileId }));
                },
                error =>
                {
                    console.log("error");
                });

            this.validate();
        },

        validate()
        {
            const showError = this.shippingProfileId <= 0 || this.shippingProfileList.length <= 0;

            this.$store.commit("setShippingProfileShowError", showError);

            if (showError)
            {
                NotificationService.error(
                    TranslationService.translate("Ceres::Template.checkoutCheckShippingProfile")
                );
            }
        },

        getTooltip(shippingProfileId, methodOfPaymentId)
        {
            let translationKey = "";

            const params = {};

            for (let i = 0; i < this.shippingProfileList.length; i++)
            {
                const shippingProfile = this.shippingProfileList[i];

                if (shippingProfile.parcelServicePresetId === shippingProfileId)
                {
                    if (this.paymentContainerIsOverwritten)
                    {
                        translationKey = "Ceres::Template.checkoutChangePaymentMethodToHint";
                        params.paymentMethodNames = shippingProfile.allowedPaymentMethodNames.join(",");
                    }
                    else
                    {
                        translationKey = "Ceres::Template.checkoutChangePaymentMethodHint";
                    }
                    break;
                }
            }

            return TranslationService.translate(translationKey, params);
        },

        isPaymentMethodExcluded(shippingProfile, selectedPaymentMethodId)
        {
            if (isDefined(shippingProfile.excludedPaymentMethodIds))
            {
                return shippingProfile.excludedPaymentMethodIds.includes(selectedPaymentMethodId);
            }
            else
            {
                return false;
            }
        },

        handleKeydown(event, inputId)
        {
            if (event.key === "Enter" || event.keyCode === 13)
            {
                event.preventDefault();
                document.getElementById(inputId).click();
            }
        }
    }
});
